import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { requestCategoryService } from "../services/requestCategory.service";

export const useDeleteRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (requestId: string) => requestCategoryService.deleteRequest(requestId),
    onSuccess: () => {
      // Invalidate requests query to refetch the updated list
      queryClient.invalidateQueries({ queryKey: ["requests"] });
      toast.success("Request deleted", { duration: 2000 });
    },
    onError: (error) => {
      console.error("Failed to delete request:", error);
      toast.error("Failed to delete request", { duration: 2000 });
    },
  });
};
